import { PRODUCT_IMAGES } from "../../utils/imagesMap"

export const data = {
  seo: {
    title: "2-in-1 Shampoo and Conditioner",
    description:
      "A physician-formulated 2-in-1 shampoo and conditioner that promotes a healthy scalp, which is essential for hair growth.",
  },

  banner: {
    mobileImage:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7etY1WCyZuJZqWDiwNW0HE/e090ca06869b485dc1941f32c9d32e81/men-active-cleanse-hero-mobile.jpg?fl=progressive",
    tabletImage:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4Q0Yn1KCeNAYPUZjJTyCFk/9035b0607ca2c7b7aad42c5d81f8608d/men-active-cleanse-hero-tablet.jpg?fl=progressive",
    desktopImage:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2ueoPfXGb4uFGuaU9qSVZ/c3d458dc93d181efeb816e8eca1f33c0/men-active-cleanse-hero.jpg?fl=progressive",
    heading:
      "Don’t undercut your hair growth routine with traditional shampoo.",
  },
  comparison: {
    heading: "THE RIGHT SHAMPOO CAN UNLOCK YOUR HAIR’S POTENTIAL.",
    items: {
      cleanse: {
        title: "Active Cleanse",
        mobileImage:
          "https://images.ctfassets.net/0rbfqd9c4jdo/1tPw9DSdxjSjhdhGO0uohD/f04f0ffd11d5af0aaf3eb0628a3c2f3c/comparison-cleanse-mobile.png",
        desktopImage:
          "https://images.ctfassets.net/0rbfqd9c4jdo/6uvbDpOegQckqLkqxYbP4C/3916b7e4a9d547c12d5de6c1508bc764/comparison-cleanse.png",
        bullets: `
         <ul><li>Physician-formulated for thinning hair.</li>
<li>First and only 2-in-1 to be certified scalp microbiome-friendly.<sup>3</sup></li>
<li>100% natural fragrance.</li>
<li>Formulated without sulfates and provides a deep cleanse without stripping the scalp.<sup>2</sup></li>
<li>Konjac Root provides silicone-free conditioning without weighing hair down for fuller volume.<sup>4,5</sup></li></ul>
 `,
      },
      other: {
        title: "Most Other Guys",
        mobileImage:
          "https://images.ctfassets.net/0rbfqd9c4jdo/dGOQlAYL1kJuUPwEEFyl2/650fe09a11cabc4b538c57d9e43ee359/comparison-cleanse-other-mobile.png",
        desktopImage:
          "https://images.ctfassets.net/0rbfqd9c4jdo/ERbCORAcgvd5tX04ggO13/4cb168faab173d26f9ee33d66f94a312/comparison-cleanse-other.png",
        bullets: `
         <ul><li>May disrupt the scalp microbiome.</li>
<li>Contains synthetic fragrances that may disrupt hormones and hair growth.</li>
<li>Made with sulfates (SLS and SLES) that can lead to dryness and scalp irritation.</li>
<li>Made with heavy silicones that can weigh hair down and reduce volume.</li></ul>
 `,
      },
    },
  },

  nutraceutical: {
    ctaLabel: `Shop the Duo Now`,
    link: `/men/products/thinning-hair-supplements-and-shampoo-conditioner`,
    mobileImage:
      "https://images.ctfassets.net/0rbfqd9c4jdo/oSUGoMeDtPCRXDo7Zgw6i/fa5f2bd33d4292f482d178a079a15b56/mens-ingr-mobile.jpg?fl=progressive",
    tabletImage:
      "https://images.ctfassets.net/0rbfqd9c4jdo/9Pc4si0FyhrIdI45mOH5e/c4071cf0a32a867aa60d384874a1104d/mens-ingr-tablet.jpg?fl=progressive",
    desktopImage:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1vXVkPJNemihiW736Y2xhB/6542feb6efe3d782bfaac4a56f9fcad3/mens-ingr-desktop.jpg?fl=progressive",
    duoImage:
      "https://images.ctfassets.net/0rbfqd9c4jdo/729lEQwDNQqmd9VIDoL3pp/d2659c761bbb62e39939cab6f23beb24/mens-cleanse-square.png",
    heading: "Looking for more scalp coverage?",
    subheading:
      "Our 2-in-1 is a powerful addition to your hair routine, but our Nutraceutical is the foundation. Because growth is powered from within. With both in your arsenal, hair thinning doesn’t stand a chance.",
    stat: "72%",
    statinfo:
      "of men saw improvements after 6 months with Nutrafol Men Hair Growth Nutraceutical.<sup>6</sup>",
  },

  radioArea: {
    subtitle: `When you’re doing such great work to build a powerful hair growth routine, the last thing you want to do is get in the way of your own progress with a traditional shampoo.
<br/><br/>This revolutionary 2-in-1 shampoo and conditioner, the first to be certified microbiome-friendly, is clinically tested to unclog pores, hydrate dry scalps, and support men’s unique scalp needs, so that your hair can finally thrive to the fullest.<sup>1-3</sup>`,
    title: "2-in-1 shampoo & conditioner",
    mainimg: `https://images.ctfassets.net/0rbfqd9c4jdo/7za0qlS4jvieWrrH4zj7z5/e032f360b39acbfc73f731ab14a867ee/atc-cleanse-main.jpg?fl=progressive`,
    mainalt: `Improves your dry, flaky scalp. Unclogs hair follicles so hair can grow. Boosts visible volume with lightweight conditioners for easier styling and coverage. The only 2-in-1 to be certified microbiome-friendly.`,
    shoppingImg: PRODUCT_IMAGES.ACTIVECLEANSE.label1,
    supplement_label: PRODUCT_IMAGES.ACTIVECLEANSE.label0,
    options: [
      {
        sku: "ACTIVECLEANSE-N01",
        segmentName: "Men's 2-in-1 Shampoo and Conditioner",
        id: "onetimepruchase",
        title: "Single Bottle",
        subtitle: "One bottle, delivered once.",
      },
    ],
    icons: [
      {
        text: "Physician-formulated to support thinning hair",
      },
      {
        text: "Supports the scalp microbiome so hair can thrive",
      },
      {
        text: `Certified<br class="show-md-up"/> microbiome-friendly`,
      },
    ],
    questions: [
      {
        title: "Recommended usage",
        answer: `<p>Apply a dollop to fingertips. Massage into wet scalp and hair, then rinse. Repeat as necessary. Gentle enough for daily use. </p>
        `,
      },
      {
        title: "Benefits for Men",
        answer: `
          <p>Dissolves build-up<sup>1</sup></p>
          <p>Replenishes hydration and improves a dry, flaky scalp<sup>1</sup></p>
          <p>Conditions and detangles without weighing hair down<sup>2</sup></p>
          <p>Supports the scalp microbiome<sup>3</sup></p>
          <p>Maintains a healthy scalp barrier<sup>1</sup></p>
          `,
      },
      {
        title: "Formulated without",
        answer: `
          <p>Parabens, phthalates, silicones, sulfates, synthetic fragrance.</p>
        `,
      },
    ],
    imageArea: [
      {
        image: `https://images.ctfassets.net/0rbfqd9c4jdo/8guUjTLvl7VvmpSRxj56X/734a39e04ff2c3fd8d4bbd4f1a827a4d/cleanse-atc-stat-desktop.jpg?fl=progressive`,
        mobileImage: `https://images.ctfassets.net/0rbfqd9c4jdo/24VHuyR2jy3yyI420OioWA/0e7e5db860489997c4be9dda626248c2/cleanse-atc-stat-mobile.jpg?fl=progressive`,
        name: "Stats",
        alt: "96% noticed a reduction in dry, flaky scalp. 96% noticed less product build-up and scalp congestion. (Citation for Nutrafol. Data on file. 2024.)",
      },
      {
        video: `https://nutrafol.com/media/video_storage/Nutrafol_Active_Cleanse_366x480.mp4`,
        poster: `https://images.ctfassets.net/0rbfqd9c4jdo/4JBf6Bkt3pmSh7G9lpsEou/c2acbd83fdae3b37040975498ba5ffe0/cleanse-atc-video.jpg?fl=progressive`,
        hasSound: false,
        quote:
          "I have been taking Nutrafol for over a year now and it has really transformed my hair.",
        name: "Seth",
        more: "Nutrafol Customer",
        videoName: "Stephen Video Testimonial",
      },
      {
        image: `https://images.ctfassets.net/0rbfqd9c4jdo/4qtPRIX33J1lJ9BQMnLV2v/89db37d2a24fcf97406e63a136872880/cleanse-atc-certified.jpg`,
        mobileImage: `https://images.ctfassets.net/0rbfqd9c4jdo/1VpibCNi6w6juZsVth60sB/d9a43fb9e0130d598ed4c05bf944d35b/cleanse-atc-certified-mobile.jpg`,
        name: "certified",
        alt: "The only 2-in-1 to be certified microbiome-friendly. (Citation for Certified microbiome-friendly by MyMicrobiome)",
      },
      {
        image: `https://images.ctfassets.net/0rbfqd9c4jdo/6AfuRpvZFyZGbRJeFpVKUO/71604c3c1ad9a560461bb75304a0606d/cleanse-atc-info-desktop.jpg?fl=progressive`,
        mobileImage: `https://images.ctfassets.net/0rbfqd9c4jdo/j9IpEM4SefxzW3dBQMViq/4018405f69fef0ed3ca3a036c1ad5af8/cleanse-atc-info-mobile.jpg?fl=progressive`,
        name: "info",
        alt: "Why does my scalp microbiome matter? It’s a pretty big deal, actually. Your scalp microbiome is the armor for your hair follicles, protecting them from factors that can hinder growth. And the ingredients in traditional shampoos weaken that armor. So if you want visibly thicker hair, you’ll want this new 2-in-1 shampoo that’s specifically formulated to support your scalp microbiome, not attack it.",
      },
    ],
    coreUpsell: {
      product: {
        name: "Combine our 2-in-1 with our <b>award-winning hair growth supplement</b> to target key root causes of thinning from within.",
        description: "Supports hair health from the inside and out.",
        image:
          "https://images.ctfassets.net/0rbfqd9c4jdo/729lEQwDNQqmd9VIDoL3pp/d2659c761bbb62e39939cab6f23beb24/mens-cleanse-square.png",
        imageAlt: "Nutrafol Men Duo",
      },
      button: {
        label: "Shop the Duo Now",
        path: "/men/products/thinning-hair-supplements-and-shampoo-conditioner/",
      },
    },
  },

  atcAreaData: {
    options: [
      {
        sku: "ACTIVECLEANSE-N01",
        id: "onemonthsub",
        title: "Single Bottle",
        subtitle: "One bottle, delivered once.",
      },
    ],
  },
  faqContact: {
    pt: ["64px", "64px", "80px", "128px"],
    pb: ["32px", "32px", "40px", "64px"],
    hasTopBorder: false,
    heading: "We’re serious about facts. Ask away.",

    questions: [
      {
        title: "Why do men and women need different shampoos and conditioners?",
        answer: `Men and women have different scalp needs. Men tend to have more oily scalps and a weaker scalp barrier, which leads to more scalp concerns compared to women. 
        <br/>        <br/>
        Active Cleanse is physician-formulated for the bio-specific needs of men's scalps and supports the scalp barrier to create a foundation for 
        hair to grow and thrive. The 2-in-shampoo and conditioner is microbiome-friendly and gently removes pore-clogging build-up without stripping. Science-backed and formulated without silicones, it detangles without weighing hair down for visibly thicker, fuller hair.   
        `,
      },
      {
        title: "What is 2-in-1 shampoo and conditioner?",
        answer: `
        A 2-in-1 shampoo and conditioner combines the cleansing properties of a shampoo with the moisturizing benefits of a conditioner. Nutrafol’s Active Cleanse is a physician-formulated 2-in-1 men’s shampoo and conditioner, with exfoliating enzymes and prebiotics, that dissolves excess oil and build-up while supporting the scalp microbiome for visibly healthy hair.  
        `,
      },
      {
        title:
          "Will this 2-in-1 shampoo and conditioner help with hair growth?",
        answer: `
Our scalp care formulas will not grow your hair. Our physician-formulated hair care products were designed with clean ingredients to support thinning hair and scalp health. We recommend using them with our Hair Growth Nutraceuticals to visibly improve volume and texture while supporting hair health from within.  
        `,
      },
      {
        title:
          "Should I use this 2-in-1 shampoo and conditioner with the other Nutrafol Men products?",
        answer: `Your hair needs are unique—and your hair growth regimen should be tailored accordingly. Our 2-in-1 shampoo and conditioner will not grow your hair. However, it will balance your scalp microbiome and cultivate an ecosystem where healthy hair can thrive. We recommend using it with your Hair Growth Nutraceutical to optimize your hair health.
        <br/>        <br/>
      You can personalize your hair growth regimen by taking our Hair Wellness Quiz.
              `,
      },
      {
        title: "How often should I wash my hair?",
        answer: `
We recommend washing your hair frequently as dirt, pollution, dust particles, and styling products can clog pores and throw off the balance of your scalp microbiome. Active Cleanse is gentle enough to be used daily.

        `,
      },
    ],
  },
  references: {
    pt: ["32px", "32px", "40px", "64px"],
    pb: ["64px", "64px", "80px", "128px"],
    type: "men",
    items: [
      "Nutrafol. Data on file. 2024.",
      "Nutrafol. Data on file. 2024.",
      "The first and only 2-in-1 shampoo and conditioner to be certified microbiome-friendly by MyMicrobiome.",
      "Nutrafol, Data on File, 2019.",
      "Nutrafol, Data on File, 2023.",
      "Stephens, T., et al. JCAD. 2022./Nutrafol. Data on file. 2022.",
      "Townsend, et al. J Clin Aesth Dermatol. 2023.",
    ],
  },
}
